export function AppProvider({
  children,
  components,
}: {
  components: any;
  children?: React.ReactElement;
}) {
  return (
    <>
      {components.reduceRight((componentTree: any, cfg: [any, any]) => {
        const [Provider, props] = Array.isArray(cfg) ? cfg : [cfg, {}];
        return <Provider {...props}>{componentTree}</Provider>;
      }, children)}
    </>
  );
}
